// API
export const GET_PRODUCT_LIMITS_API = 'statistics/products/uuid/limits';

// Queries
export const QUERY_PRODUCT_LIMITS = 'QUERY_PRODUCT_LIMITS';
